import React from 'react';
import UniversalAddItemForm from '../shared/UniversalAddItemForm';

const FactureItemManagement = ({ refFAC, onSuccess, codeEnt }) => {
  return (
    <UniversalAddItemForm
      refField="REF_FAC"
      refValue={refFAC}
      onSuccess={onSuccess}
      codeEnt={codeEnt}
      priceType="selling"
      enableBatch={true}
      useArticleList={false}
      submitButtonText="Add all to Facture"
    />
  );
};

export default FactureItemManagement;
